export default function IcoODS() {
	return (
		<svg width="36" height="64" viewBox="0 0 36 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.9329 29.8823V30.0061C21.9329 31.5934 22.8335 32.2689 24.7472 32.5277C26.0193 32.6964 26.3456 33.0455 26.3456 33.6759V33.7322C26.3456 34.3176 25.9292 34.7677 25.0848 34.7677H24.9836C24.1393 34.7677 23.6888 34.3063 23.6888 33.2031H21.8654V33.3045C21.8654 35.4209 22.9573 36.3439 25.0285 36.3439C27.0887 36.3439 28.2032 35.3645 28.2032 33.6759V33.5635C28.2032 31.9312 27.2349 31.278 25.3214 31.0192C24.0379 30.8504 23.7791 30.5128 23.7791 29.8709V29.8148C23.7791 29.2519 24.2067 28.8467 24.9385 28.8467H25.04C25.963 28.8467 26.3119 29.3756 26.3119 30.5239H28.1355V30.2875C28.1355 28.2275 27.1899 27.2705 25.0285 27.2705C23.0248 27.2705 21.9329 28.295 21.9329 29.8823ZM7.44434 32.0324V31.5821C7.44434 28.5426 8.51386 27.2707 10.7878 27.2707C13.0729 27.2707 14.1422 28.5426 14.1422 31.5821V32.0324C14.1422 35.0718 13.0729 36.3439 10.7878 36.3439C8.51386 36.3439 7.44434 35.0718 7.44434 32.0324ZM10.844 34.7679C11.9698 34.7679 12.285 33.7885 12.285 32.0324V31.5821C12.285 29.8259 11.9698 28.8465 10.844 28.8465H10.7426C9.61691 28.8465 9.29064 29.8259 9.29064 31.5821V32.0324C9.29064 33.7885 9.61691 34.7679 10.7426 34.7679H10.844ZM17.621 36.1974H14.9305V27.417H17.621C20.2327 27.417 21.3246 28.5426 21.3246 31.582V32.0324C21.3246 35.0718 20.2327 36.1974 17.621 36.1974ZM17.5196 34.6215C19.0396 34.6215 19.4672 33.7885 19.4672 32.0324V31.582C19.4672 29.8259 19.0396 28.993 17.5196 28.993H16.7543V34.6215H17.5196Z"
				fill="white"
			/>
			<path
				d="M0.740287 34.5293C0.767158 33.2967 1.78831 32.3192 3.02096 32.3463C4.25356 32.3732 5.23104 33.3943 5.20399 34.6269C5.17712 35.8596 4.15597 36.837 2.92332 36.81C1.69072 36.7831 0.713416 35.762 0.740287 34.5293Z"
				fill="white"
			/>
			<path
				d="M11.0391 17.13C11.0391 15.897 12.0386 14.8974 13.2714 14.8974C14.5044 14.8974 15.5039 15.897 15.5039 17.13C15.5039 18.3628 14.5044 19.3623 13.2714 19.3623C12.0386 19.3623 11.0391 18.3628 11.0391 17.13Z"
				fill="white"
			/>
			<path
				d="M29.6323 26.1934C29.6323 24.9605 30.6319 23.9609 31.8648 23.9609C33.0978 23.9609 34.0972 24.9605 34.0972 26.1934C34.0972 27.4262 33.0978 28.4258 31.8648 28.4258C30.6319 28.4258 29.6323 27.4262 29.6323 26.1934Z"
				fill="white"
			/>
			<path
				d="M21.8071 45.6825C21.8071 44.4495 22.8067 43.4502 24.0395 43.4502C25.2724 43.4502 26.272 44.4495 26.272 45.6825C26.272 46.9155 25.2724 47.915 24.0395 47.915C22.8067 47.915 21.8071 46.9155 21.8071 45.6825Z"
				fill="white"
			/>
			<path
				d="M2.44727 39.4259C2.44727 38.1929 3.4468 37.1933 4.67974 37.1933C5.91275 37.1933 6.91212 38.1929 6.91212 39.4259C6.91212 40.6587 5.91275 41.6582 4.67974 41.6582C3.4468 41.6582 2.44727 40.6587 2.44727 39.4259Z"
				fill="white"
			/>
			<path
				d="M26.6086 21.3741C26.6086 20.1411 27.6082 19.1416 28.8412 19.1416C30.0739 19.1416 31.0735 20.1411 31.0735 21.3741C31.0735 22.6069 30.0739 23.6064 28.8412 23.6064C27.6082 23.6064 26.6086 22.6069 26.6086 21.3741Z"
				fill="white"
			/>
			<path
				d="M26.2717 42.5773C26.2717 41.3443 27.2713 40.3447 28.5043 40.3447C29.737 40.3447 30.7366 41.3443 30.7366 42.5773C30.7366 43.81 29.737 44.8096 28.5043 44.8096C27.2713 44.8096 26.2717 43.81 26.2717 42.5773Z"
				fill="white"
			/>
			<path
				d="M6.16772 43.451C6.16772 42.2181 7.16727 41.2186 8.4001 41.2186C9.63304 41.2186 10.6326 42.2181 10.6326 43.451C10.6326 44.6841 9.63304 45.6836 8.4001 45.6836C7.16727 45.6836 6.16772 44.6841 6.16772 43.451Z"
				fill="white"
			/>
			<path
				d="M2.44727 23.7841C2.44727 22.5511 3.4468 21.5516 4.67974 21.5516C5.91275 21.5516 6.91212 22.5511 6.91212 23.7841C6.91212 25.0171 5.91275 26.0166 4.67974 26.0166C3.4468 26.0166 2.44727 25.0171 2.44727 23.7841Z"
				fill="white"
			/>
			<path
				d="M21.8071 18.0878C21.8071 16.855 22.8067 15.8554 24.0395 15.8554C25.2724 15.8554 26.272 16.855 26.272 18.0878C26.272 19.3208 25.2724 20.3203 24.0395 20.3203C22.8067 20.3203 21.8071 19.3208 21.8071 18.0878Z"
				fill="white"
			/>
			<path
				d="M16.4031 47.0421C16.4031 45.8091 17.4026 44.8096 18.6356 44.8096C19.8686 44.8096 20.8679 45.8091 20.8679 47.0421C20.8679 48.275 19.8686 49.2744 18.6356 49.2744C17.4026 49.2744 16.4031 48.275 16.4031 47.0421Z"
				fill="white"
			/>
			<path
				d="M30.7363 31.911C30.7363 30.6781 31.7359 29.6785 32.9689 29.6785C34.2016 29.6785 35.2012 30.6781 35.2012 31.911C35.2012 33.144 34.2016 34.1436 32.9689 34.1436C31.7359 34.1436 30.7363 33.144 30.7363 31.911Z"
				fill="white"
			/>
			<path
				d="M16.4031 16.3866C16.4031 15.1539 17.4026 14.1543 18.6356 14.1543C19.8686 14.1543 20.8679 15.1539 20.8679 16.3866C20.8679 17.6196 19.8686 18.6191 18.6356 18.6191C17.4026 18.6191 16.4031 17.6196 16.4031 16.3866Z"
				fill="white"
			/>
			<path
				d="M0.739746 28.998C0.739746 27.765 1.73917 26.7655 2.97212 26.7655C4.20506 26.7655 5.20461 27.765 5.20461 28.998C5.20461 30.2309 4.20506 31.2305 2.97212 31.2305C1.73917 31.2305 0.739746 30.2309 0.739746 28.998Z"
				fill="white"
			/>
			<path
				d="M11.0394 46.1397C11.0664 44.9071 12.0874 43.9296 13.32 43.9566C14.5527 43.9835 15.5301 45.0047 15.5031 46.2373C15.4762 47.4699 14.4552 48.4474 13.2226 48.4204C11.9898 48.3935 11.0125 47.3723 11.0394 46.1397Z"
				fill="white"
			/>
			<path
				d="M29.296 37.587C29.323 36.3543 30.3441 35.3769 31.5768 35.4039C32.8095 35.431 33.7867 36.4519 33.7598 37.6846C33.7328 38.9173 32.7118 39.8947 31.4792 39.8676C30.2466 39.8407 29.2691 38.8196 29.296 37.587Z"
				fill="white"
			/>
			<path
				d="M6.16827 19.7451C6.19508 18.5125 7.21629 17.5351 8.44889 17.5619C9.68154 17.589 10.659 18.6101 10.632 19.8428C10.6051 21.0754 9.58395 22.0527 8.35129 22.0258C7.11864 21.9988 6.14139 20.9778 6.16827 19.7451Z"
				fill="white"
			/>
		</svg>
	);
}
